<script setup>
import { useRouter } from 'vue-router';
const router = useRouter();

const goToLogin = () => {
    router.push("/login");
}

</script>
<template>
    <div v-if="false" style="display: flex; justify-content: center; align-items: center; position: absolute; width: 100%; height: 100%; overflow:hidden; top: 0; left: 0; background-color: rgba(0, 0, 0, .4); z-index: 10000;">
        <div style="width: 90vw; padding: 10px; background-color: white;">
            <div>
                <p>Não é possível utilizar o APP.<br>
                    Entre em contato com seu profissional para entender mais.
                </p>
                <div style="width: 100%; display: flex; justify-content: end;">
                    <button @click="goToLogin" style="background-color: rgb(184, 1, 1); color: white; border: none; padding: 4px; padding-left: 15px; padding-right: 15px; border-radius: 5px;">Sair</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang='postcss' scoped>

</style>